import axios from 'axios';

const API_URL = 'https://xlxn-yfz8-5hn7.n7d.xano.io/api:_9vL_xEJ';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const fetchFiles = async (folderId = null, page = 1, perPage = 20) => {
  try {
    const params = new URLSearchParams();
    if (folderId) {
      params.append('folder_id', folderId);
    }
    params.append('page', page);
    params.append('perPage', perPage);
    const response = await api.get(`/file?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar arquivos:', error);
    throw error;
  }
};

export const fetchFolders = async () => {
  try {
    const response = await api.get('/folder');
    return response.data;
  } catch (error) {
    console.error('Error fetching folders:', error);
    throw error;
  }
};

export const uploadFile = async (files, folderId = null) => {
  try {
    const formData = new FormData();
    Array.from(files).forEach(file => {
      formData.append('files[]', file);
    });
    if (folderId) {
      formData.append('folder_id', folderId);
    }
    const response = await api.post('/file/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};

export const deleteFile = async (id) => {
  try {
    const response = await api.delete(`/file/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting file:', error);
    throw error;
  }
};

export const createFolder = async (name, parentFolderId = null) => {
  try {
    const response = await api.post('/folder', {
      name,
      parent_folder_id: parentFolderId
    });
    return response.data;
  } catch (error) {
    console.error('Error creating folder:', error);
    throw error;
  }
};

export const deleteFolder = async (id) => {
  try {
    const response = await api.delete(`/folder/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting folder:', error);
    throw error;
  }
}; 